var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 13.8333L10.667 13.8333C11.1531 13.8333 11.6192 13.64 11.9629 13.2962C12.3066 12.9525 12.4999 12.4864 12.5 12.0003L12.5 8.00033C12.5 7.72419 12.2761 7.50033 12 7.50033C11.7239 7.50033 11.5 7.72419 11.5 8.00033L11.5 12.0003C11.4999 12.2212 11.4121 12.433 11.2559 12.5892C11.0997 12.7454 10.8879 12.8333 10.667 12.8333L4 12.8333C3.77906 12.8333 3.5674 12.7454 3.41113 12.5892C3.25493 12.433 3.16708 12.2212 3.16699 12.0003L3.16699 5.33334C3.16699 5.11232 3.25485 4.90075 3.41113 4.74447C3.56741 4.58819 3.77899 4.50033 4 4.50033L8 4.50033C8.27603 4.50033 8.49982 4.27632 8.5 4.00033C8.5 3.72419 8.27614 3.50033 8 3.50033L4 3.50033C3.51377 3.50033 3.04792 3.69362 2.7041 4.03744C2.36029 4.38125 2.16699 4.84711 2.16699 5.33334L2.16699 12.0003C2.16708 12.4864 2.36036 12.9525 2.7041 13.2962C3.0479 13.6399 3.51385 13.8333 4 13.8333Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6868 3.02018C13.8821 2.82492 13.8821 2.50841 13.6868 2.31315C13.4916 2.11789 13.1751 2.11789 12.9798 2.31315L6.9798 8.31315C6.78454 8.50841 6.78454 8.82492 6.9798 9.02018C7.17507 9.21544 7.49157 9.21544 7.68684 9.02018L13.6868 3.02018Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 3.16699L12.8333 3.16699L12.8333 6C12.8333 6.27614 13.0572 6.5 13.3333 6.5C13.6095 6.5 13.8333 6.27614 13.8333 6L13.8333 2.66699C13.8333 2.39085 13.6095 2.16699 13.3333 2.16699L10.0003 2.16699C9.72419 2.16699 9.50034 2.39085 9.50034 2.66699C9.50051 2.94299 9.7243 3.16699 10.0003 3.16699Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpen);
export default __webpack_public_path__ + "static/media/open.3105f5389cc8be548ec884e92c8b33f1.svg";
export { ForwardRef as ReactComponent };